import { render } from "./Veranstaltungen.vue?vue&type=template&id=d03a75cc&scoped=true"
import script from "./Veranstaltungen.vue?vue&type=script&lang=js"
export * from "./Veranstaltungen.vue?vue&type=script&lang=js"

import "./Veranstaltungen.vue?vue&type=style&index=0&id=d03a75cc&scoped=true&lang=css"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03a75cc"]])

export default __exports__